import { flattenObject } from "./flattenObject";

/**
 * @typedef PatchOption
 * @type {object}
 * @property {string} op
 * @property {string} path
 * @property {string | number} value
 *
 * @param rowsToUpdate
 * @returns Array.<PatchOption> - transform updated values from rows to patch options
 */
export const computePatchOptionsFromRows = (rowsToUpdate) => {
  const patchOptions = {};
  rowsToUpdate.forEach((rowToUpdate) => {
    const { subscriptionId, ...changedColumns } = rowToUpdate;
    const changes = flattenObject(changedColumns, "/");
    patchOptions[subscriptionId] = [];
    Object.keys(changes).map((changePath) => {
      patchOptions[subscriptionId].push({
        op: "add",
        path: changePath,
        value: changes[changePath],
      });
    });
  });
  return patchOptions;
};
